import { useMemo } from "react";
import cn from "clsx";
import OrganizationLogo from "../OrganizationLogo";
import { jsx as _jsx } from "react/jsx-runtime";
var TopIconSidebar = function TopIconSidebar(_ref) {
  var _OrganizationLogo, _user$organization;
  var isDark = _ref.isDark,
    logoUrl = _ref.logoUrl,
    tourSelector = _ref.tourSelector,
    sidebarCollapsed = _ref.sidebarCollapsed,
    organizationLogo = _ref.organizationLogo,
    user = _ref.user,
    className = _ref.className,
    isSidebarV2Enabled = _ref.isSidebarV2Enabled;
  var currentLogo = useMemo(function () {
    var _ref2 = organizationLogo || {},
      expanded = _ref2.expanded,
      collapsed = _ref2.collapsed;
    if (sidebarCollapsed) {
      /** TODO: when we have a logo for the collapsed sidebar, use that */
      return collapsed;
    }
    return expanded || _OrganizationLogo || (_OrganizationLogo = /*#__PURE__*/_jsx(OrganizationLogo, {
      isDark: isDark,
      user: user
    }));
  }, [isDark, organizationLogo, sidebarCollapsed, user]);
  return (/*#__PURE__*/
    /**
     * This error is because currentLogo is not a fully ReactNode.
     * Looks like typescript can't infer that currentLogo is a Jsx element when using the useMemo hook
     */
    _jsx("a", {
      className: cn("relative flex items-center justify-center mb-8", !isSidebarV2Enabled && 'h-72 max-h-72 py-24 border-solid border-b', isDark ? 'border-base-lighter-16' : 'border-gray-lighter', className),
      href: logoUrl,
      "aria-label": (user === null || user === void 0 ? void 0 : (_user$organization = user.organization) === null || _user$organization === void 0 ? void 0 : _user$organization.name) || 'Crehana',
      "data-tour": tourSelector,
      style: {
        flexGrow: 0
      },
      children: currentLogo
    })
  );
};
export default TopIconSidebar;